export const COLOR_LIST = [
  "#1abc9c",
  "#16a085",
  "#2ecc71",
  "#27ae60",
  "#3498db",
  "#2980b9",
  "#9b59b6",
  "#8e44ad",
  "#34495e",
  "#2c3e50",
  "#f1c40f",
  "#f39c12",
  "#e67e22",
  "#d35400",
  "#e74c3c",
  "#c0392b",
];

const TEXT_COLOR_LIST = [
  "#fff",
  "#fff",
  "#000",
  "#fff",
  "#fff",
  "#fff",
  "#fff",
  "#fff",
  "#fff",
  "#fff",
  "#000",
  "#fff",
  "#fff",
  "#fff",
  "#fff",
  "#fff",
];

export const SITE_ICON_COLOR_LIST = [
  "#8247FF",
  "#FFC264",
  "#FF7E47",
  "#479CFF",
  "#47C8FF",
  "#FD99C3",
  "#7EDC7C",
  "#CE95EA",
  "#9EE7E3",
  "#FF4D8D",
];

export const getRandomColor = (text: string, colorList: string[]) => {
  if (!text) {
    return colorList[0];
  }

  // const letterCode = text && text.length > 0 ? text.charCodeAt(0) : 0;
  const letterCode = text
    .split("")
    .reduce((prev, curr) => prev + curr.charCodeAt(0), 0);

  return colorList[letterCode % colorList.length];
};

export const getRandomTextColor = (text: string) => {
  if (!text) {
    return TEXT_COLOR_LIST[0];
  }

  // const letterCode = text && text.length > 0 ? text.charCodeAt(0) : 0;
  const letterCode = text
    .split("")
    .reduce((prev, curr) => prev + curr.charCodeAt(0), 0);

  return TEXT_COLOR_LIST[letterCode % TEXT_COLOR_LIST.length];
};
